import { Module } from '@nestjs/common';
import { ItemconfigurationService } from './itemconfiguration.service';
import { ItemconfigurationController } from './itemconfiguration.controller';
import { TypeOrmModule } from '@nestjs/typeorm';
import { Itemconfiguration } from './entities/itemconfiguration.entity';
import { ItemConfigurationRepo } from './repositories/itemconfiguration.repo';


@Module({
  imports: [
    TypeOrmModule.forFeature([Itemconfiguration])
  ],
  controllers: [ItemconfigurationController],
  providers: [ItemconfigurationService],
  exports:[ItemconfigurationService]
})
export class ItemconfigurationModule { }
